import { http_client } from "@/plugins/http_client";

const exportarPlantilla = async () => await http_client('/api/v1/establecimientos/exportar-plantilla', {}, 'get', {}, true, 'blob');
const importarEstablecimientos = async (data) => await http_client('/api/v1/establecimientos/importar', data, 'post', { 'Content-Type': 'multipart/form-data' }, true, 'json');

export default {
  exportarPlantilla,
  importarEstablecimientos
}